import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import {
  getToken,
  clearAllTokens,
  setToken,
  setRefreshToken,
} from "../lib/auth";
import { apiAlova, authAlova } from "../lib/alova";
import { encryptData, decryptData } from "../lib/helpers";

const STORAGE_KEY = "user";
const AuthContext = createContext(null);

// ==================== API Profile ====================
export async function getProfile(force = false) {
  return;
  const res = await apiAlova
    .Get(`/auth/profile?${force ? `ts=${Date.now()}` : ""}`)
    .send();

  if ("error" in res) throw new Error("Gagal ambil profile");
  return res.data;
}

export async function login(username, password) {
  const res = await authAlova
    .Post("/auth/login", { username, password })
    .send();

  if ("error" in res) {
    throw new Error(res.message || "Login gagal");
  }

  // ✅ kalau success
  const loginData = res.data;
  if (loginData) {
    setToken(loginData.tokens.access_token);
    setRefreshToken(loginData.tokens.refresh_token);
  }

  return { success: true, message: res.message };
}

// ==================== Provider ====================
export function AuthProvider({ children }) {
  let initialUser = null;

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      const decrypted = decryptData(stored);
      initialUser = decrypted ? JSON.parse(decrypted) : null;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  const [user, setUser] = useState(initialUser);
  const [loading, setLoading] = useState(true);

  // =========== ACTIONS ===========
  const actions = {
    setUser: (u) => {
      setUser(u);
      const encrypted = encryptData(JSON.stringify(u));
      localStorage.setItem(STORAGE_KEY, encrypted);
    },

    clearUser: () => {
      setUser(null);
      localStorage.removeItem(STORAGE_KEY);
      setLoading(false);
    },

    logout: () => {
      clearAllTokens();
      localStorage.removeItem(STORAGE_KEY);
      setUser(null);
      setLoading(false);
    },

    setLoading,
  };

  const loadProfile = useCallback(async () => {
    if (!getToken()) {
      actions.clearUser();
      return;
    }

    try {
      const profile = await getProfile(true);

      if (JSON.stringify(profile) !== JSON.stringify(user)) {
        actions.setUser(profile);
      }
    } catch {
      actions.clearUser();
    }
  }, [user]);

  useEffect(() => {
    (async () => {
      await loadProfile();
      setLoading(false);
    })();
  }, []);

  return (
    <AuthContext.Provider value={[{ user, loading }, actions]}>
      {children}
    </AuthContext.Provider>
  );
}

// ==================== HOOK ====================
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
